/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface CancelByIdsRequest
 */
export interface CancelByIdsRequest {
  /**
   *
   * @type {Array<string>}
   * @memberof CancelByIdsRequest
   */
  taskIds: Array<string>;
}

/**
 * Check if a given object implements the CancelByIdsRequest interface.
 */
export function instanceOfCancelByIdsRequest(
  value: object,
): value is CancelByIdsRequest {
  if (!("taskIds" in value) || value["taskIds"] === undefined) return false;
  return true;
}

export function CancelByIdsRequestFromJSON(json: any): CancelByIdsRequest {
  return CancelByIdsRequestFromJSONTyped(json, false);
}

export function CancelByIdsRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CancelByIdsRequest {
  if (json == null) {
    return json;
  }
  return {
    taskIds: json["taskIds"],
  };
}

export function CancelByIdsRequestToJSON(json: any): CancelByIdsRequest {
  return CancelByIdsRequestToJSONTyped(json, false);
}

export function CancelByIdsRequestToJSONTyped(
  value?: CancelByIdsRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    taskIds: value["taskIds"],
  };
}
